
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share/video/embed/[slug]",
      function () {
        return require("private-next-pages/share/video/embed/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share/video/embed/[slug]"])
      });
    }
  